import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import R from 'ramda'

export const companyLogoSizes = {
  SMALL: 's',
  MEDIUM: 'm',
  LARGE: 'l',
  XLARGE: 'xl'
}

export const initialState = {
  items: {}
}

const items = handleActions({
  FETCH_COMPANY_LOGO_FULFILLED: (state, { payload }) => ({
    ...state,
    [payload.id]: payload
  })
}, initialState.items)

export default combineReducers({
  items
})

export const getMediaItems = state => R.pathOr({}, ['mediaItems', 'items'])(state)

export const getMediaItemById = (state, id) =>
  R.compose(
    R.prop(id),
    getMediaItems
  )(state)



// WEBPACK FOOTER //
// ./src/reducers/mediaItems.js